module.exports = __webpack_public_path__ + "img/7873d44.jpg";